import { createListenerMiddleware, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import addCartListeners from './cart/listeners';
import addDashboardListeners from './dashboard/listeners';
import addDeviceListeners from './device/listeners';
import addEventDetailsListeners from './eventDetails/listeners';
import addGuestListeners from './guest/listeners';
import addMenuListeners from './menu/listeners';
import addOrderListeners from './order/listeners';
import addDatadogListeners from './services/datadogListeners';
import addUserListeners from './user/listeners';

declare type ExtraArgument = { testUtils?: { debounceCallback?: (action: UnknownAction) => void } };

export const listenerMiddleware = createListenerMiddleware<
  unknown,
  ThunkDispatch<unknown, unknown, UnknownAction>,
  ExtraArgument
>({ extra: {} });
export type AppStartListening = typeof listenerMiddleware.startListening;

addDashboardListeners(listenerMiddleware.startListening);
addGuestListeners(listenerMiddleware.startListening);
addOrderListeners(listenerMiddleware.startListening);
addCartListeners(listenerMiddleware.startListening);
addMenuListeners(listenerMiddleware.startListening);
addUserListeners(listenerMiddleware.startListening);
addEventDetailsListeners(listenerMiddleware.startListening);
addDeviceListeners(listenerMiddleware.startListening);
addDatadogListeners(listenerMiddleware.startListening);
